import { doc, Timestamp, updateDoc } from "firebase/firestore";
import { AiResponse } from "../../models/interfaces/ai-response";
import FirestoreCondition from "../../models/interfaces/firestore-condition";
import FirestoreOrder from "../../models/interfaces/firestore-order";
import { User } from "../../models/interfaces/user";
import FirestoreService from "./firestore-service";
import getFirebase from "../firebase";

const COLLECTION_NAME = "aiResponses";
const { db } = getFirebase();

const add = async (aiResponse: AiResponse, currentUser: User | null = null) => {
    return FirestoreService.add<AiResponse>(COLLECTION_NAME, aiResponse, currentUser);
};

const deleteById = async (id: string) => {
    FirestoreService.deleteById(COLLECTION_NAME, id);
};

const get = async (id: string) => {
    return FirestoreService.get<AiResponse>(COLLECTION_NAME, id);
};

const getBy = async (
    conditions: FirestoreCondition[],
    order: FirestoreOrder[] = [],
    limit?: number
) => {
    return FirestoreService.getBy<AiResponse>(COLLECTION_NAME, conditions, order, limit);
};

const getCountBy = async (conditions: FirestoreCondition[]) => {
    return FirestoreService.getCountBy(COLLECTION_NAME, conditions);
};

const getAll = async (order: FirestoreOrder[] = []) => {
    return FirestoreService.getAll<AiResponse>(COLLECTION_NAME, order);
};

const getAllByOrganizationId = async (organizationId: string) => {
    return getBy([
        {
            field: "organizationId",
            operator: "==",
            value: organizationId,
        },
    ]);
};

const getSnapshot = (id: string, listener: Function) => {
    return FirestoreService.getSnapshot<AiResponse>(COLLECTION_NAME, id, listener);
};

const getSnapshotBy = (
    conditions: FirestoreCondition[],
    order: FirestoreOrder[] = [],
    listener: Function
) => {
    return FirestoreService.getSnapshotBy<AiResponse>(COLLECTION_NAME, conditions, order, -1, listener);
};

const save = async (aiResponse: AiResponse, currentUser: User | null = null) => {
    return FirestoreService.save<AiResponse>(COLLECTION_NAME, aiResponse, currentUser);
};

const update = async (aiResponse: AiResponse, currentUser: User | null = null) => {
    return FirestoreService.update<AiResponse>(COLLECTION_NAME, aiResponse, currentUser);
};

const updateFields = async (aiResponse: AiResponse, fields: object, currentUser: any | null = null) => {
    const docRef = doc(db, COLLECTION_NAME, aiResponse.id!);
    const updateData = {
        ...fields,
        updated: Timestamp.now(),
        updatedBy: currentUser?.id ?? "",
    };

    updateDoc(docRef, updateData);
};

const setFeedback = async (aiResponse: AiResponse, isLiked: boolean | null) => {
    const docRef = doc(db, COLLECTION_NAME, aiResponse.id!);
    await updateDoc(docRef, {
        isLiked,
        updated: Timestamp.now(),
    });
};

const AiResponseService = {
    add,
    deleteById,
    get,
    getBy,
    getCountBy,
    getAll,
    getAllByOrganizationId,
    getSnapshot,
    getSnapshotBy,
    save,
    update,
    updateFields,
    setFeedback,
};

export default AiResponseService;